import { IValidationErrorListItem } from 'external-services/booking-validation-service/bookingValidation.types';
import { IBooking } from 'shared-types/index';

export enum SaveStatus {
  Fresh = 'Fresh', // save hasn't yet been attempted, user still entering in details
  Pending = 'Pending', // attempted, but has validation errors to fix
  ValidationFailed = 'ValidationFailed', // validation passed, but something went wrong when saving to pouchDB
  ValidationSuccessful = 'ValidationSuccessful', // validation passed and save was successful
  SaveFailed = 'SaveFailed',
  SaveSuccessful = 'SaveSuccessful',
  SaveInProgress = 'SaveInProgress',
  SaveSuccessfulAndClosing = 'SaveSuccessfulAndClosing', // saved, but hasn't finished animating out yet
}

export interface IValidationState {
  originalBooking: IBooking; // if mode === BookingMode.BookingMode this can be used as the moved booking data
  canSave: boolean;
  staffNewBooking: {
    isMandatory: boolean;
    isEnabled: boolean;
  };
  staffEditBooking: {
    isMandatory: boolean;
    isEnabled: boolean;
  };
  staffValue: string;
  saveStatus: SaveStatus;
  saveAttempted: boolean;
  tableSeaterFullyLoaded: boolean;
  cantSaveMessageList: IValidationErrorListItem[];
  emailErrorMsg: string;
  paymentPhone: string;
  isPaymentPhoneValid: boolean;
  paymentEmail: string;
  isPaymentEmailValid: boolean;
  isPaymentEmailUpdateChecked: boolean;
  isPaymentPhoneUpdateChecked: boolean;
  validPhoneMessage: string;
  isBookedByValid: boolean;
  isBookedByEmailValid: boolean;
  isBookedByPhoneValid: boolean;
  bookedByErrors: string[];
  bookedByPaymentEmail?: string;
  bookedByPaymentPhone?: string;
  isBookedByPaymentEmailValid?: boolean;
  isBookedByPaymentPhoneValid?: boolean;
  isSavingBookedByEmail?: boolean;
  isSavingBookedByPhone?: boolean;
  bookedByPaymentEmailErrorMsg?: string;
  bookedByPaymentPhoneErrorMsg?: string;
  isSavePaymentEmailToCustomer?: boolean;
  isSavePaymentPhoneNumberToCustomer?: boolean;
  saveSeatAttempted?: boolean;
  saveNewWalkinAttempted?: boolean;
  isConfirmedSeat?: boolean;
  isConfirmedNewWalkinCustomer?: boolean;
  isBookingExternallyUpdated?: boolean;
}
